import { Route } from '@angular/router';
import { IsAdminGuard, LoggedInGuard } from '@spotter/guards/login-guard';

/** Adds the routes for user and profile pages.s */
export function addUserPageRoutes(): Route[] {
  return [
    {
      path: 'user/:id',
      loadComponent: () => import('../pages/users/user-page/user-page.component').then(m => m.UserPageComponent)
    },
    {
      path: 'user/:id/email', canActivate: [IsAdminGuard],
      loadComponent: () => import('../pages/users/user-email-page/user-email-page.component').then(m => m.UserEmailPageComponent)
    },

    { path: 'profile', redirectTo: 'dashboard', pathMatch: 'full' },
    {
      path: 'profile/dashboard', canActivate: [LoggedInGuard],
      loadComponent: () => import('../pages/profile/user-dashboard/user-dashboard.page').then(m => m.UserDashboardPage)
    },
    {
      path: 'profile/my-sightings', canActivate: [LoggedInGuard],
      loadComponent: () => import('../pages/profile/user-sightings/user-sightings.page').then(m => m.UserSightingsPage)
    },
    {
      path: 'profile/my-achievements', canActivate: [LoggedInGuard],
      loadComponent: () => import('../pages/profile/user-achievements/user-achievements.page').then(m => m.UserAchievementsPage)
    },
    {
      path: 'profile/my-favourites', canActivate: [LoggedInGuard],
      loadComponent: () => import('../pages/profile/user-favourites/user-favourites.page').then(m => m.UserFavouritesPage)
    },
  ];
}